import {CommandActionInterface, CommandActionBase} from '../command-action';
import {Participant} from "../../../providers/global.service";
import {filter} from "rxjs/operators";
import {GlobalServiceProvider} from "../../../providers/global.service";
import {Component, Inject, NgModule} from "@angular/core";

import {Command, SimpleCommand} from "../command-parser";



export class CreateCmdAction extends CommandActionBase implements CommandActionInterface{

  componentName:string;
  commandString:string;
  public global:GlobalServiceProvider; //can't find a way to inject it, have to set it from outside

  // public simpleCommand :SimpleCommand;


  savedItem : any;


  constructor(){
    super();
  }




  do(commandString?){



    return new Promise((resolve, reject)=>
    {

      let simpleCommand = SimpleCommand.parseSingleCommand(commandString);
      let args:any = SimpleCommand.parseArguments(commandString);
      debugger;
      let firstWordInSubstring = simpleCommand.substring.split(' ')[0];
      switch (firstWordInSubstring) {
        case "participant":
          this.createParticipant(args, resolve, reject, commandString, this, "participant");
          break;
        case "document":
          this.createDocument(args,resolve, reject, commandString, this, "document");
          break;

        case "group":
          //debugger;
          break;

      }


    })
  }


  getResult(){
    debugger;
    return this.savedItem;
  }

  destroy() {

  }


  public static getNew(){
    return new CreateCmdAction();
  }

  saveParticipant(p){
    let savePromise =  this.global.createParticipant(p);
    return savePromise;
  }


  saveDocument(d){
    let savePromise = this.global.createDocument(d);
    return savePromise;
  }



  createParticipant(args, resolve, reject, commandString, commandAction, commandDetail){

    if(!args.username){
      reject({message:'Please provide a username for the participant, e.g., <span class="command">create participant -username myUser</span>',
        type:"user"});
      return;
    }

    //setup the participant object
    let p: Participant = {
      username: (args.username ? args.username.trim() : args.username),
      email: (args.email ? args.email.trim() : args.email),
      name: (args.name? args.name.trim() : args.name),
      password: (args.password? args.password.trim() : args.password)
      // authenticationToken:
    }
    debugger;
    //save it
    this.saveParticipant(p).then((result)=>{
      this.savedItem = result;
      resolve({commandString, commandAction, commandDetail});
    }).catch((saveParticipantError)=>{
      debugger;
    });
    //debugger;

  }


  createDocument(args, resolve, reject, commandString, commandAction, commandDetail){
    debugger;
    if(!args.name){
      reject({message:"Please provide a name for the document, e.g., <span class='command'>create document -name myDocument</span>", type:"user"});
      return;
    }

    let d:any = {
      name:args.name,
    };

    this.saveDocument(d).then((result)=>{
      this.savedItem = result;
      resolve({commandString, commandAction, commandDetail})
    }).catch((saveDocumentError)=>{
      debugger;
    })
  }

}


export class CreateParticipantCmdAction extends CreateCmdAction{

}

export class CreateDocumentCmdAction extends CreateCmdAction{

}



// WEBPACK FOOTER //
// ./src/components/commands/create-cmd/create-cmd-action.ts